import React from 'react';
import { Helmet } from 'react-helmet';

function Privacy_Policy_Seo() {
    return (
        <div>
            <Helmet>
                <title>Privacy Policy | Pay Quik</title>
                <meta name="keywords" content="" />
                <meta name="description" content="" />
                <meta property="og:title" content="Privacy Policy | Pay Quik" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="https://pay-quik.co.uk/assets/images/logo/site-logo.png" />
                <meta property="og:url" content="https://pay-quik.co.uk/privacy-policy" />
                <meta name="twitter:title" content="Privacy Policy | Pay Quik" />
                <meta name="twitter:description" content="" />
                <meta name="twitter:image" content="https://pay-quik.co.uk/assets/images/logo/site-logo.png" />
            </Helmet>
        </div>
    )
}

export default Privacy_Policy_Seo
